import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { api } from "../lib/api";
import RouteCard from "../components/RouteCard";

export default function Routes() {
  const { t } = useTranslation();
  const [routes, setRoutes] = useState([]);
  const [tab, setTab] = useState("oficiales");

  useEffect(() => {
    api.listRoutes(tab === "oficiales" ? { official: true } : { official: false }).then(setRoutes).catch(() => {});
  }, [tab]);

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8" data-testid="routes-page">
      <header className="flex items-end justify-between flex-wrap gap-4 mb-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">{t("routes.eyebrow")}</div>
          <h1 className="mt-1 font-display text-5xl sm:text-6xl uppercase tracking-tighter leading-none">{t("routes.title")}</h1>
          <p className="mt-3 text-[#A3A3A3] max-w-xl">{t("routes.desc")}</p>
        </div>
        <Link
          to="/rutas/nueva"
          className="btn-brutal bg-[#FEBA01] text-black font-display uppercase text-base px-5 py-2.5 shadow-brutal-white inline-flex items-center gap-2"
          data-testid="route-new-btn"
        >
          <Plus size={16} /> {t("home.routesForDogs", { defaultValue: "Crear ruta" })}
        </Link>
      </header>

      <div className="flex gap-2 mb-6">
        {[["oficiales", t("routes.tabOfficial")], ["comunidad", t("routes.tabCommunity")]].map(([k, label]) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            data-testid={`routes-tab-${k}`}
            className={`px-4 py-2 font-mono uppercase text-xs tracking-widest border-2 ${
              tab === k ? "bg-[#FEBA01] text-black border-[#FEBA01]" : "border-[#333] text-[#F5F5F5] hover:border-[#FEBA01]"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {routes.map((r) => <RouteCard key={r.id} route={r} />)}
        {routes.length === 0 && (
          <div className="col-span-full p-10 text-center border-2 border-dashed border-[#333] text-[#A3A3A3] font-mono uppercase text-xs tracking-widest">
            {tab === "oficiales" ? t("routes.soon") : t("routes.beFirst")}
          </div>
        )}
      </div>
    </div>
  );
}
